// React Select v5.8.0 reference documentation: 
// -- https://react-select.com/home
// -- https://react-select.com/upgrade-to-v2#upgrade-guide-for-v2
// -- https://react-select.com/styles#the-unstyled-prop
// -- https://github.com/JedWatson/react-select
// -- https://github.com/JedWatson/react-select/discussions/5148

import React from 'react';
import { components } from 'react-select';

export const CustomDropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.59 0L6 4.58L1.41 0L0 1.41L6 7.41L12 1.41L10.59 0Z" fill="#4F4C4D"/>
        </svg>
    </components.DropdownIndicator>
);

export const colorStyles = {
    control: (styles, {selectProps}) => ({
        ...styles,
        backgroundColor: '#fff',
        borderRadius: '0px',
        border: selectProps.error? '1px solid #E70000':'1px solid #007C10',
        color: '#3F3F3F',
        cursor: 'default',
        borderSpacing: '0',
        borderCollapse: 'spacing',
        height: '36px',
        outline: 'none',
        overflow: 'hidden',
        position: 'relative',
        width: '100%',
        boxSizing: 'border-box',
        boxShadow: 'none',
        minHeight: '36px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignSelf: 'stretch',
        ':hover': {
            border: selectProps.error? '1px solid #E70000':'1px solid #007C10',
            boxShadow: 'none',
        },
    }),
    valueContainer: (styles) => ({
        ...styles,
        padding: '0 8px 0 12px',
    }),
    placeholder: (styles) => ({
        ...styles,
        color: 'var(--hrb-functional-grey, #A7A7A7)',
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '16px',
        margin: 0,
    }),
    singleValue: (styles) => ({
        ...styles,
        color: '#3F3F3F',
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '16px',
        margin: 0,
    }),
    menu: (styles) => ({
        ...styles,
        borderBottomRightRadius: '0px',
        borderBottomLeftRadius: '0px',
        backgroundColor: '#fff',
        border: '1px solid #007C10',
        borderTopColor: '#e6e6e6',
        boxShadow: '0 1px 0 rgba(0, 0, 0, 0.06)',
        boxSizing: 'border-box',
        marginTop: '-1px',
        maxHeight: '200px',
        position: 'absolute',
        left: '0',
        top: '100%',
        width: '100%',
        zIndex: '1',
        borderRadius: '0px',
    }),
    menuList: (styles) => ({
        ...styles,
        maxHeight: '198px',
        overflowY: 'auto',
        borderTopColor: 'transparent',
        borderTopColor: 'transparent'
    }),
    option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        boxSizing: 'border-box',
        backgroundColor: isFocused ? 'rgba(0, 124, 16, 0.25)' : isSelected ? 'rgba(0, 124, 16, 0.4)' : '#fff',
        color: isFocused ? '#3F3F3F' : isSelected ? '#3F3F3F' : '#666666',
        cursor: 'pointer',
        display: 'block',
        padding: '8px 10px',

        ':active': {
            backgroundColor: 'rgba(0, 124, 16, 0.25)'
        }
    }),
    indicatorSeparator: (styles) => ({
        ...styles,
        backgroundColor: 'transparent',
    }),
    dropdownIndicator: (styles, { selectProps }) => ({
        ...styles,
        cursor: 'pointer',
        padding: '0',
        width: '24px',
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#4F4C4D',
        overflow: 'hidden',
        flexShrink: 0,
        position: 'relative',
        transform: `rotate(${selectProps.menuIsOpen ? 180 : 0}deg)`,
        transition: 'transform 0.2s',
        "svg": {
            width: '12px',
            height: '7.41px',
            fill: '#4F4C4D',
        },
    }),
    clearIndicator: (styles) => ({
        ...styles,
        "svg": {
            color: 'transparent',
        }
    }),
    input: (styles) => ({
        ...styles,
        caretColor: 'transparent',
    }),
}